var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.4079 19.9223C39.4079 25.7342 36.4916 31.3701 33.0288 35.1792C29.5659 38.9883 24.4424 40 19.1588 40C13.8753 40 8.56509 39.1907 5.10493 35.3816C1.64477 31.5725 0 25.7313 0 19.9223C0 14.1133 1.95933 8.6152 5.42216 4.80903C8.88498 1.00286 13.8779 0 19.1588 0C24.4397 0 29.8992 0.4897 33.362 4.29587C36.8248 8.10205 39.4079 14.1104 39.4079 19.9223Z",
    fill: "#F81958"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9764 17.1884L13.3983 10.1049L17.2387 8.70707L19.8168 15.7906L21.9734 23.2208L19.0718 24.2769L15.9764 17.1884ZM20.822 30.502L19.3621 26.4909L23.2025 25.093L24.6624 29.1042L20.822 30.502Z",
    fill: "#FAFF29"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.2d99946dd31e4d8452a3cfb99f6305b4.svg";
export { ForwardRef as ReactComponent };